import { render } from "./ErrorMessage.vue?vue&type=template&id=5a38b3f8"
const script = {}
script.render = render

export default script